import React, { useState } from 'react';
import { PageHeader } from '../components/PageBits';
import { galleryCategories } from '../mock/data';
import { X } from 'lucide-react';

const Gallery = () => {
  const [open, setOpen] = useState(null);
  const [activeTab, setActiveTab] = useState('All');

  const tabs = ['All', ...galleryCategories.map(c => c.title)];
  const displayCategories = activeTab === 'All'
    ? galleryCategories
    : galleryCategories.filter(c => c.title === activeTab);

  return (
    <>
      <PageHeader kicker="Gallery" title="Moments of service," accent="culture, and togetherness." intro="The REFOCC gallery captures the spirit of the organization through photographs of gatherings, events, community interactions, women's wing activities, and regional moments." />

      {/* Category tabs */}
      <section className="py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap gap-2 justify-center">
          {tabs.map(t => (
            <button key={t} onClick={() => setActiveTab(t)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeTab === t ? 'bg-refocc-dark-mid text-refocc-cream' : 'bg-white border border-refocc-dark/15 text-refocc-dark/75 hover:border-refocc-dark'}`}>{t}</button>
          ))}
        </div>
      </section>

      {/* Categorized gallery */}
      <section className="py-8 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {displayCategories.map(category => (
            <div key={category.title} className="mb-12">
              {activeTab === 'All' && (
                <h2 className="font-serif text-2xl md:text-3xl text-refocc-dark mb-6 pb-3 border-b border-refocc-dark/10">{category.title}</h2>
              )}
              <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [&>*]:mb-4">
                {category.images.map((src, i) => (
                  <div key={i} onClick={() => setOpen(src)} className="break-inside-avoid rounded-2xl overflow-hidden cursor-pointer bg-refocc-dark/10 hover:shadow-lg transition-shadow">
                    <img src={src} alt={`${category.title} ${i+1}`} loading="lazy" className="w-full h-auto img-hover" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {open && (
        <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <button onClick={() => setOpen(null)} className="absolute top-5 right-5 text-white/80 hover:text-white"><X size={28}/></button>
          <img src={open} alt="Preview" className="max-w-full max-h-[90vh] rounded-2xl shadow-2xl" />
        </div>
      )}
    </>
  );
};

export default Gallery;
